import ExtendBooking from "../../../Components/User/Bookings/ExtendBooking/ExtendBooking";
import { ColDef, GridReadyEvent, ICellRendererParams } from "ag-grid-community";
import { getBookings } from "../../../Redux/Bookings/BookingsActions";
import Loading from "../../../Components/Common/Loading/Loading";
import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";
import { AppDispatch, RootState } from "../../../Redux/store";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { HiDotsVertical } from "react-icons/hi";
import styles from "./Bookings.module.scss";
import { AgGridReact } from "ag-grid-react";
import { Link } from "react-router";
import moment from "moment";

interface BookingsType {
  bookingId: number;
  startTime: string;
  endTime: string;
  createdAt: string;
  description: string;
  statusName: string;
  amenityName: string;
  pdflink: string;
}

const defaultColDef: ColDef = {
  resizable: true,
  sortable: true,
  filter: false,
  wrapText: true,
  autoHeight: true,
  unSortIcon: true,
};

function Bookings() {
  const dispatch = useDispatch<AppDispatch>();
  const { bookings, bookingsLoading } = useSelector(
    (state: RootState) => state.bookings,
  );
  const [rowData, setRowData] = useState<BookingsType[]>([]);
  const [gridApi, setGridApi] = useState<any>(null);
  const [isExtendBookingModalOpen, setIsExtendBookingModalOpen] =
    useState(false);
  const [selectedBooking, setSelectedBooking] = useState<any>(null);
  const columnDefs: ColDef[] = [
    {
      headerName: "Booking Start",
      field: "startTime",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) =>
        moment(params?.data?.startTime).format("hh:mm A"),
    },
    {
      headerName: "Booking End",
      field: "endTime",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => moment(params?.data?.endTime).format("hh:mm A"),
    },
    {
      headerName: "Booking Date",
      field: "startTime",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) =>
        moment(params?.data?.startTime).format("MM/DD/YYYY"),
    },
    {
      headerName: "Amenity",
      field: "amenityName",
      flex: 1,
      minWidth: 150,
    },
    {
      headerName: "Description",
      field: "description",
      flex: 2,
      minWidth: 200,
    },
    {
      headerName: "Status",
      field: "statusName",
      flex: 1,
      minWidth: 100,
      cellClass: (params) => {
        return params?.data?.statusName === "Completed"
          ? "CompletedText"
          : params?.data?.statusName === "Pending"
            ? "pendingText"
            : "text-black-500";
      },
    },
    {
      colId: "actions",
      sortable: false,
      suppressAutoSize: true,
      suppressMovable: true,
      suppressNavigable: true,
      editable: false,
      cellStyle: {
        pointerEvents: "all",
        userSelect: "none",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-end",
      },
      cellRenderer: (params: ICellRendererParams) => {
        return (
          <div className={styles.iconContainer}>
            <Menu
              direction="left"
              menuButton={
                <MenuButton>
                  <HiDotsVertical className={styles.icon} />
                </MenuButton>
              }
              transition
              portal
            >
              {params?.data?.statusName !== "Completed" && (
                <MenuItem
                  onClick={() => {
                    setSelectedBooking(params?.data);
                    setIsExtendBookingModalOpen(true);
                  }}
                >
                  Extend Booking
                </MenuItem>
              )}
              <MenuItem
                onClick={() => {
                  window.open(params?.data?.pdflink, "_blank");
                }}
              >
                Download PDF
              </MenuItem>
            </Menu>
          </div>
        );
      },
    },
  ];

  const onGridReady = (params: GridReadyEvent) => {
    setGridApi(params?.api);
    params?.api?.sizeColumnsToFit();
  };

  useEffect(() => {
    if (!gridApi) return;

    const handleResize = () => {
      gridApi?.sizeColumnsToFit();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [gridApi]);

  useEffect(() => {
    dispatch(getBookings());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (bookings) {
      setRowData(bookings);
    }
  }, [bookings]);

  if (bookingsLoading) {
    return <Loading />;
  }

  return (
    <React.Fragment>
      <ExtendBooking
        isOpen={isExtendBookingModalOpen}
        setIsOpen={setIsExtendBookingModalOpen}
        selectedBooking={selectedBooking}
      />
      <div className={styles.mainContainer}>
        <div className={styles.topContainer}>
          <div className={styles.headingContainer}>
            <h1 className={styles.heading}>My Bookings</h1>
          </div>
          <Link to="/bookings/create" className={styles.buttonContainer}>
            <button className={styles.button}>Create Booking</button>
          </Link>
        </div>
        <div className={styles.gridContainer}>
          <AgGridReact
            className={styles.grid}
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            onGridReady={onGridReady}
            pagination={true}
            paginationPageSize={10}
            paginationPageSizeSelector={[5, 10, 20, 50, 100]}
            animateRows={true}
            domLayout="autoHeight"
          />
        </div>
      </div>
    </React.Fragment>
  );
}

export default Bookings;
